var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('autogen-view',{ref:"autogenview"}),(_vm.tariffAction)?_c('edit-tariff-value-wizard',{attrs:{"showAction":_vm.tariffAction,"resource":_vm.tariffResource}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }